<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="message-template-list-sidebar" position="left" lockedOpen="gt-md">
        <message-template-list-sidebar></message-template-list-sidebar>
    </fuse-sidebar>

    <div class="center">

        <div class="content-card" style="overflow-y: scroll;">
            <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
                <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
                      fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

                    <div class="h2 mb-24">{{'Message template data'|translate}}</div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                            <mat-label>{{'Name'|translate}}</mat-label>
                            <input matInput formControlName="name" required>
                            <mat-error>{{'Name is required!'|translate}}</mat-error>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                            <mat-label>{{'Description'|translate}}</mat-label>
                            <textarea matInput formControlName="description" required [rows]="20"></textarea>
                            <mat-error>{{'Description is required!'|translate}}</mat-error>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100">
                            <mat-label>{{'Notification account'|translate}}</mat-label>
                            <mat-select formControlName="notificationAccount">
                                <mat-option [value]="account.id" *ngFor="let account of notificationAccounts">
                                    {{account.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-checkbox formControlName="customerRegistrationMessage" fxFlex="100">
                            <mat-label>{{'Customer registration message'|translate}}</mat-label>
                        </mat-checkbox>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-checkbox formControlName="customerConfirmMessage" fxFlex="100">
                            <mat-label>{{'Customer confirm message'|translate}}</mat-label>
                        </mat-checkbox>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-checkbox formControlName="orderPaymentStartedMessage" fxFlex="100">
                            <mat-label>{{'Order payment started message'|translate}}</mat-label>
                        </mat-checkbox>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-checkbox formControlName="orderPaidMessage" fxFlex="100">
                            <mat-label>{{'Order paid message'|translate}}</mat-label>
                        </mat-checkbox>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-checkbox formControlName="orderPaymentErrorMessage" fxFlex="100">
                            <mat-label>{{'Order payment error message'|translate}}</mat-label>
                        </mat-checkbox>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-checkbox formControlName="orderAssignedToCartMessage" fxFlex="100">
                            <mat-label>{{'Order assigned to card message'|translate}}</mat-label>
                        </mat-checkbox>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-checkbox formControlName="orderImpossibleToAssignToCardMessage" fxFlex="100">
                            <mat-label>{{'Impossible to assign order to card message'|translate}}</mat-label>
                        </mat-checkbox>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-checkbox formControlName="resetPasswordMessage" fxFlex="100">
                            <mat-label>{{'Reset password message'|translate}}</mat-label>
                        </mat-checkbox>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-checkbox formControlName="deletedAccountMessage" fxFlex="100">
                            <mat-label>{{'Delete account message'|translate}}</mat-label>
                        </mat-checkbox>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-checkbox formControlName="accountDeletionMessage" fxFlex="100">
                            <mat-label>{{'Delete account message'|translate}} - {{'Mobile app'|translate}}</mat-label>
                        </mat-checkbox>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-checkbox formControlName="tempPasswordMessage" fxFlex="100">
                            <mat-label>{{'Temporary password message'|translate}}</mat-label>
                        </mat-checkbox>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <button mat-raised-button type="button" color="primary" (click)="showTestMessageDialog(form.value)">
                                {{'Test it!'|translate}}
                            </button>&nbsp;
                            <button mat-raised-button type="submit" color="accent">
                                {{'Save'|translate}}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
